import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    description: 'shippedPlaceholder.title',
    defaultMessage: 'You have no {statusView} to view',
    id: 'VlHFmx',
  },
  description: {
    description: 'shippedPlaceholder.description',
    defaultMessage:
      'When an order ships, a new record shows up in "Recent" shipments. As tracking events become available, the shipment moves to "In Transit" or "Delivered."',
    id: 'uUL76d',
  },
  buttonContent: {
    description: 'shippedPlaceholder.buttonContent',
    defaultMessage: 'Orders > Awaiting Shipment',
    id: 'H4F7wA',
  },
  actionDescription: {
    description: 'shippedPlaceholder.actionDescription',
    defaultMessage: 'Ship one of your {link} orders',
    id: 'xwlYmb',
  },
  boldStatusView: {
    description: 'shippedPlaceholder.boldStatusView',
    defaultMessage: 'Shipments',
    id: 'hofkE8',
  },
  link: {
    description: 'shippedPlaceholder.link',
    defaultMessage: 'Awaiting Shipment',
    id: 'lGPoiw',
  },
  refundAssistGridEmptyStateDescription: {
    description: 'message displayed when there are no refunds to display on the Refunds Assist Grid',
    defaultMessage: 'When you have an unused shipping label that is eligible for a refund, it will appear here.',
    id: 'T6NYNH',
  },
  refundAssistStatusViewText: {
    description: 'bold text to display in the title of the placeholder page for Refund Assist when there are no refunds',
    defaultMessage: 'Refunds',
    id: 'ujuG2x',
  },
  learnMoreAboutRefundAssist: {
    description: 'external link text for learning more about Refund Assist',
    defaultMessage: 'Learn more about Refund Assist',
    id: 'lP66Gx',
  },
});

export default messages;
